import React from 'react';
import Reveal from '../ui/Reveal';
import ThreeDCard from '../ui/ThreeDCard';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const servicesList = [
  {
    title: "PR Strategy",
    description: "Bespoke blueprints designed to elevate your brand's positioning.",
    icon: FiIcons.FiTrendingUp
  },
  {
    title: "Media Outreach",
    description: "Securing high-impact features in top-tier publications.",
    icon: FiIcons.FiGlobe
  },
  {
    title: "Personal Branding",
    description: "Transforming leaders into recognized industry authorities.",
    icon: FiIcons.FiUserCheck
  },
  {
    title: "Content Storytelling",
    description: "Crafting narratives with literary precision.",
    icon: FiIcons.FiEdit3
  },
  {
    title: "Event PR",
    description: "Curating and amplifying high-profile events.",
    icon: FiIcons.FiMic
  }
];

const Services = () => {
  return (
    <section id="services" className="py-24 md:py-32 bg-navy-900 text-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-20">
          <Reveal>
            <span className="text-gold-500 uppercase tracking-widest text-sm font-semibold block mb-4">Our Expertise</span>
            <h2 className="font-serif text-4xl md:text-6xl mb-6">Execution & Vision</h2>
            <div className="w-24 h-[1px] bg-gold-500 mx-auto"></div>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesList.map((service, index) => (
            <Reveal key={index} delay={index * 0.1}>
              <ThreeDCard className="h-full">
                <div className="group h-full bg-navy-800/50 backdrop-blur-sm p-8 border border-white/5 hover:border-gold-500/50 transition-all duration-300">
                  <div className="mb-6 text-gold-500 transform transition-transform group-hover:translate-z-20">
                    <SafeIcon icon={service.icon} className="text-3xl" />
                  </div>
                  <h3 className="font-serif text-2xl mb-4 group-hover:text-gold-400">
                    {service.title}
                  </h3>
                  <p className="text-gray-400 font-light leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </ThreeDCard>
            </Reveal>
          ))}
          
          <Reveal delay={0.5}>
            <ThreeDCard className="h-full">
              <div className="bg-gold-500 p-8 flex flex-col justify-center h-full text-navy-900">
                <h3 className="font-serif text-3xl mb-4">Need a custom strategy?</h3>
                <a href="#contact" className="inline-flex items-center uppercase tracking-widest text-sm font-bold border-b-2 border-navy-900 pb-1 w-fit">
                  Let's discuss <SafeIcon icon={FiIcons.FiArrowRight} className="ml-2" />
                </a>
              </div>
            </ThreeDCard>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Services;